import { AxiosServicesByName } from "./AxiosServices";



export enum ProductActionStatus {
    PENDING = "pending",
    SUCCESS = "success",
    ERROR = "error"
}

export function encodeQueryParams(params: Record<string, any>) {
    return new URLSearchParams(params).toString()
}


export const getProductActions = async (params: {
    status: ProductActionStatus[],
    checkoutId: number
}) => {
    const queryString = encodeQueryParams(params)
    const endpoint = "/product-manager-action/me"
    const URL = endpoint + "?" + queryString
    return await AxiosServicesByName.get(URL);
};

